/* global google, markers */
import googleMapStyles from './styles';
/* this function is called on every page load */

$(function () {
  // get array of every element with specified class
  var maps = document.querySelectorAll('.js-googleCTAMap');

  if (maps.length > 0) {
    if (maps.length > 1) {
      // if multiple maps, loop through maps and pass in the correspnding marker
      maps.forEach(function (map, i) {
        generateMap(map, [markers[i]]);
      });
    } else {
      // if one or less maps, pass in the markers
      generateMap(maps[0], markers);
    }
  }
});
/* function to generate a map, takes an element and array of markers */

var generateMap = function generateMap(element, mapMarkers) {
  // make sure mapMarkers is valid
  if (typeof mapMarkers === 'undefined' || window.innerWidth < 1) return;
  var map = new google.maps.Map(element, {
    zoom: 13,
    // center: { lat: 37.25, lng: -95.5 },
    styles: googleMapStyles,
    disableDefaultUI: true,
    zoomControl: false,
    gestureHandling: 'none'
  });
  var bounds = new google.maps.LatLngBounds();

  if (Array.isArray(mapMarkers)) {
    if (mapMarkers.length > 1) {
      /* loop through mapMarkers and create a marker for each */
      Array.from(mapMarkers).forEach(function (item, index) {
        // Shift the values up one, because arrays are 0 indexed
        index++;
        generateMarker(item, map, bounds, index);
        map.fitBounds(bounds);
      });
    } else {
      var marker = generateMarker(mapMarkers[0], map, bounds);
      map.setCenter(marker.position);
    }
  } else {
    var _marker = generateMarker(mapMarkers, map, bounds);

    map.setCenter(_marker.position);
  }
};

var generateMarker = function generateMarker(item, map, bounds) {
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  // Check if the item has 'marker' or not
  var lat = item.hasOwnProperty('marker') ? item.marker.lat : item.lat;
  var lng = item.hasOwnProperty('marker') ? item.marker.lng : item.lng;
  var marker = new google.maps.Marker({
    position: new google.maps.LatLng(lat, lng),
    map: map,
    // icon: mapMarker,
    zIndex: index // or -index

  });
  bounds.extend(marker.position);
  return marker;
};